import { render, staticRenderFns } from "./InputWithControl.vue?vue&type=template&id=4880f600&scoped=true"
import script from "./InputWithControl.vue?vue&type=script&lang=js"
export * from "./InputWithControl.vue?vue&type=script&lang=js"
import style0 from "./InputWithControl.vue?vue&type=style&index=0&id=4880f600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4880f600",
  null
  
)

export default component.exports